<template>
    <gj-modal
            v-bind="$attrs"
            v-on="$listeners"
            size="700XAuto"
            notFooterPadding
            :visible.sync="modalVisible"
            :confirmLoading="confirmLoading"
            @cancel="cancel"
            @close="cancel"
            @confirm="confirm">
        <template #header>
            配置视图
        </template>
        <gj-table :data="data"
                  :loading="loading"
                  :columns="columns"
                  :adapt-height="false"
                  :height="400"
                  slot="content">
            <template v-slot:op="{ row }">
                <el-button-group >
                    <el-button type="text" @click="editRow(row)">编辑</el-button>
                    <el-button style="margin-left: 20px;" type="text" @click="deleteRow(row)">删除</el-button>
                </el-button-group>
            </template>
        </gj-table>
    </gj-modal>
</template>

<script>
    import {
        deleteDelView,
    } from '@/api/common';

    import { modalMixIn } from "@/minxins";
    import TtlLocalStorage from "@/utils/storage";
    const storage = new TtlLocalStorage({
        namespace: 'VIEW'
    })
    export default {
        name: "view-list",
        props:{
            moduleName: {
                type: String,
                required: true
            },
            // 视图列表
            data: {
                type: Array,
                default () {
                    return []
                }
            },
            // 视图存储模式
            saveMode: {
                type: String,
                validator(val) {
                    return ['local', 'remote', 'mix'].includes(val)
                },
                default: 'remote'
            }
        },
        mixins: [modalMixIn],
        data () {
            return {
                loading: false,
                columns: [
                    {id: 'name', header: '视图名称', field: 'name'},
                    {id: 'op', header: '操作', field: 'slot:op', width: '120px', fixed: 'right', notCustomColumn: true}
                ]
            }
        },
        methods: {
            confirm () {
              this.cancel()
            },
            /**
             * 删除行
             * @param row
             */
            async deleteRow ({ id = '' }) {
                const modal = this.$gjCreate('gj-info-modal', {
                    props: {
                        content: '删除后不可恢复，确定要删除吗？',
                    },
                    on: {
                        cancel: () => modal.$gjDestroy(),
                        confirm: async () => {
                            modal.confirmLoading = true
                            const saveMode = this.saveMode
                            if (saveMode === 'local') {
                                const viewList = await storage.get(this.moduleName)
                                if (viewList?.length) {
                                    const index = viewList.findIndex(v => v.id === id)
                                    if (index >= 0) {
                                        viewList.splice(index, 1)
                                        await storage.set(this.moduleName, viewList)
                                        this.$gjMessage.success('删除成功')
                                    }
                                    modal.$gjDestroy();
                                    this.$emit('refresh')
                                }
                            } else {
                                const res = await deleteDelView(id)
                                if (res) {
                                    this.$gjMessage.success('删除成功')
                                    this.$emit('refresh')
                                    modal.$gjDestroy();
                                } else {
                                    this.$gjMessage.error('删除失败')
                                }
                            }
                            modal.confirmLoading = false

                        }
                    },
                });
            },
            /**
             * 编辑行
             */
            editRow (row) {
                this.$emit('edit', row)
            },
        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-button--text{
        font-size: 12px;
    }
</style>
